/**
 * Lines/polygons when {@link MapProvider.setInteractions} is active.
 * Default overlay/canvas pane is ~400 — below markerPane (600), so clicks never reached geofences.
 */
export const INTERACTIVE_VECTOR_PANE = 'gpxInteractiveVector'

/** Cluster icons when interactions are on — above {@link INTERACTIVE_VECTOR_PANE}. */
export const INTERACTIVE_MARKER_PANE = 'gpxInteractiveMarkers'

/** HTML divIcon markers when interactions are on — above cluster pane. */
export const INTERACTIVE_HTML_MARKER_PANE = 'gpxInteractiveHtmlMarkers'

/** Above ant-path polylines (overlay ~400) and default marker pane (600). */
export const POINT_CIRCLE_PANE = 'gpxPointCircles'

/**
 * Shipment track point-cloud dots.
 * z-index 655 — above {@link INTERACTIVE_VECTOR_PANE} (645) so dots are clickable over path lines,
 * below interactive markers (670) so pins stay on top.
 */
export const TRACK_VERTEX_UNDER_MARKERS_PANE = 'gpxTrackVertexUnderMarkers'
